import Component from "../abstracts/Component";

export default class UpperCaseComponent extends Component {

  constructor() {
    super();
  }

  bindEvents() {
    const elements = document.querySelectorAll('[data-force-uppercase="true"]');
    if(elements && elements.length > 0) {
      elements.forEach(element => {
        element.addEventListener("input", event => {
          element.value = event.currentTarget.value.toUpperCase();
        });
      });
    }
  }

  render() {
    super.render();
    this.bindEvents();
  }
}
